import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { removeAll } from 'common/utils/cookies'
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { RouterView } from 'vue-router'

// 监听UA变化

export default /*@__PURE__*/_defineComponent({
  __name: 'app',
  setup(__props) {

const originalUA = navigator.userAgent

const lastWidth = window.innerWidth

// 监听窗口大小以及UA变化
const handleResize = () => {
  const { innerWidth, innerHeight } = window
  // 仅判断宽度变化，窗口宽度小于768或者UA变化时，重新加载页面
  if (
    (innerWidth !== lastWidth && lastWidth >= 768) ||
    navigator.userAgent !== originalUA
  ) {
    window.location.reload()
  }
}

onMounted(() => {
  window.addEventListener('resize', handleResize)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize)
  removeAll()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(RouterView)))
}
}

})